module.exports = __webpack_public_path__ + "weathericons-regular-webfont.4618f0de2a818e7ad3fe.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/weathericons-regular-webfont.ttf
// module id = 1436
// module chunks = 2